import React from 'react'
import { Link } from 'react-router-dom'

export default function HealthcareExcellence({ data, extraClass = "" }) {
    if (!data) return null;

    return (
        <section className={`industries-excellence ${extraClass}`}>
            <div className="container">
                <div className="row">
                    <div className="col-sm-12 col-md-12 col-lg-5">
                        <div className="excellence-left">
                            {data?.subtitle && (<span className="gradient-color">  {data?.subtitle} </span>)}
                           {data?.title && (   <h2 className="heading" dangerouslySetInnerHTML={{ __html: data?.title }}/>  )}
                        </div>
                    </div>
                    <div className="col-sm-12 col-md-12 col-lg-7">
                        <div className="wow animate__animated animate__slideInRight" data-wow-delay="0.1s" data-wow-duration="1.2s" >
                            <div className="excellence-right">
                                {data?.description1 && <p>{data?.description1}</p>}
                                {data?.description2 && <p>{data?.description2}</p>}
                                {data?.buttonText && (
                                    <div className="excellence-btn">
                                        <Link to={data?.buttonLink} className="default-btn" > <span>{data?.buttonText}</span>  </Link>
                                    </div>
                                )}
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </section>
    )
}
